import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { TableRow } from "@mui/material";

import { DateFormat } from "@/components/atoms";
import { StatusColorType } from "@/components/atoms/Status/styled";

import { StyledActivityItem, StyledDate, StyledDescription, StyledStatus } from "./styled";

export type ActivitiesTableItemMobileProps = {
    activity: MyBrokerApi.Activity;
};

const ActivitiesTableItemMobile: FC<ActivitiesTableItemMobileProps> = ({ activity }) => {
    const { t } = useTranslation();

    return (
        <TableRow>
            <StyledActivityItem colSpan={2}>
                <StyledDate>
                    <DateFormat date={activity.dueDate} />
                </StyledDate>
                <StyledDescription>{activity.description}</StyledDescription>
                <StyledStatus color={StatusColorType.Success} text={activity.isClosed && t("Common.Closed")} noBullet />
            </StyledActivityItem>
        </TableRow>
    );
};

export default ActivitiesTableItemMobile;
